import { ArrowRight, Ticket, X } from "lucide-react";
import { createPortal } from "react-dom";
import { formatDate, timeFormatter } from "../../utils/utils&validatation";
import { useAppContext } from "../../context/appContext";
import { useNavigate } from "react-router-dom";
import React from "react";

const RecordItem = ({ item, onSelect }) => {
    const [hover, setHover] = React.useState(false);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "4px",
                padding: "12px",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                backgroundColor: hover ? "#efefef" : "inherit",
                transition: "0.2s ease",
                cursor: "pointer",
            }}
            onClick={onSelect}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Ticket width={30} height={30} />
            </div>

            {/* Separator */}
            <div
                style={{
                    margin: "0 10px",
                    width: "1px",
                    background: "#cbd5e1",
                    alignSelf: "stretch",
                }}
            />

            <div style={{ width: "450px" }}>
                {/* <p>QR Name: <b>{item.rec.template_name}</b></p>
                <p>Event: <b>{item.rec.event_name || "NA"}</b></p>
                <p>Slot: <b>{item.time}</b></p> */}
                <p><b>QR Name: </b>{item.rec.template_name}</p>
                <p><b>Event: </b>{item.rec.event_name || "NA"}</p>
                <p><b>Slot: </b>{item.time}</p>
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <ArrowRight
                    width={30}
                    height={30}
                    style={{ color: hover ? "" : "#efefef" }}
                />
            </div>
        </div>

    );
};

const CustomPopup = ({
    onClose = () => { },
    data = null,
}) => {
    const navigate = useNavigate();

    // const { setSelected } = useAppContext();

    const sortedRecords = data?.records?.sort((a, b) => {
        if (!a.start_time && !a.end_time) return 1;
        if (!b.start_time && !b.end_time) return -1;

        return new Date(a.start_time) - new Date(b.start_time);
    });

    const finalRecords = sortedRecords?.map(rec => {
        return {
            rec,
            time: timeFormatter(rec)
        }
    })

    return createPortal(
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(2px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "40px",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    background: "#fff",
                    width: "90%",
                    height: "70vh",
                    maxWidth: "600px",
                    borderRadius: "12px",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "16px",
                    }}
                >
                    <div>Choose Event</div>
                    <button
                        onClick={onClose}
                        style={{
                            cursor: "pointer",
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            border: "none",
                            backgroundColor: "#e2e8f0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: "background-color 0.2s ease",
                            padding: 0,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0a1a4f")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#e2e8f0")}
                    >
                        <X style={{ width: "24px", height: "24px", }} />
                    </button>

                </div>

                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        overflowY: "auto",
                        paddingRight: "6px",
                    }}
                >
                    {finalRecords.map(item => (
                        <RecordItem
                            key={item.rec._id}
                            item={item}
                            onSelect={() => { navigate(`/event-scanner/ticket-scanner/${item.rec._id}`); }}
                        />
                    ))}
                </div>
            </div>

        </div>,
        document.body
    );

};

export default CustomPopup;